<template>
  <div
    class="flex flex-col items-center justify-center text-center"
    :class="wrapperClass"
  >
    <DotLottieVue
      class="h-40 w-40 sm:h-56 sm:w-56"
      autoplay
      loop
      src="/animations/loading-list.lottie"
    />

    <Transition
      mode="out-in"
      enter-from-class="opacity-0 translate-y-2"
      leave-to-class="opacity-0 -translate-y-1"
      enter-active-class="duration-300 ease-in"
      leave-active-class="duration-200 ease-out"
    >
      <div :key="currentIndex" class="text-surface-500" role="status" aria-live="polite">
        {{ loadingTexts[currentIndex] }}...
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import { useI18n } from "vue3-i18n";

const props = defineProps<{
  wrapperClass?: string;
  messages?: string[];
}>();

const currentIndex = ref(0);
const { t } = useI18n();

const loadingTexts = computed(() =>
  props.messages?.length
    ? props.messages
    : [
        t("customLoaderText1"),
        t("customLoaderText2"),
        t("customLoaderText3"),
        t("customLoaderText4"),
      ]
);

onBeforeMount(() => {
  const interval = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % loadingTexts.value.length;
    // if (currentIndex.value === loadingTexts.value.length - 1) {
    //   clearInterval(interval);
    // }
  }, 3000);

  onBeforeUnmount(() => {
    if (interval) clearInterval(interval);
  });
});
</script>
